import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class WorkflowTaskService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const r = await withRetry(() => this.api.getAll(params), { maxRetries: 2 });
            return { success: true, data: r.data || [], pagination: r.pagination || {}, message: r.message };
        } catch (e) { throw this._handle(e, 'Failed to list workflow tasks'); }
    }

    async getById(id) {
        try {
            const r = await withRetry(() => this.api.getById(id), { maxRetries: 2 });
            return { success: true, data: r.data, message: r.message };
        } catch (e) { throw this._handle(e, 'Failed to fetch workflow task'); }
    }

    async myInbox(params = {}) {
        try {
            const r = await this.api.myInbox(params);
            return { success: true, data: r.data || [], message: r.message };
        } catch (e) { throw this._handle(e, 'Failed to fetch inbox'); }
    }

    async decide(id, decision) {
        try {
            const r = await this.api.decide(id, decision);
            return { success: true, data: r.data, message: r.message || 'Karar kaydedildi' };
        } catch (e) { throw this._handle(e, 'Failed to decide on workflow task'); }
    }

    async submitFormFill(id, body) {
        try {
            const r = await this.api.submitFormFill(id, body);
            return { success: true, data: r.data, message: r.message || 'Form gönderildi' };
        } catch (e) { throw this._handle(e, 'Failed to submit workflow form'); }
    }

    async forward(id, body) {
        try {
            const r = await this.api.forward(id, body);
            return { success: true, data: r.data, message: r.message || 'Görev iletildi' };
        } catch (e) { throw this._handle(e, 'Failed to forward workflow task'); }
    }

    _handle(error, fallback) {
        if (error instanceof ApiError) throw error;
        if (error.statusCode || error.status) throw ApiError.fromResponse(error);
        throw new ApiError(error.message || fallback, 500, 'UNKNOWN_ERROR', error);
    }
}
